import {FC, useEffect, useRef} from 'react'
import {useLayout} from '../../../../_metronic/layout/core'
import {ForumsSearchPage} from './ForumsSearchPage'

const ForumsSearchWrapper: FC = () => {
  const {config, setLayout} = useLayout()
  const restoreRef = useRef(config)

  useEffect(() => {
    restoreRef.current = config

    setLayout({
      ...config,
      header: {...config.header, display: true},
      aside: {...config.aside, display: false},
      toolbar: {...config.toolbar, display: false},
      footer: {...config.footer, display: false},
    })

    document.body.classList.add('searchable-page-active')

    return () => {
      document.body.classList.remove('searchable-page-active')
      setLayout(restoreRef.current)
    }
  }, [])

  return <ForumsSearchPage />
}

export {ForumsSearchWrapper}
